import { getClipPlaybackRate, VIDEO_EDITOR_TRACK_TYPE } from "./constants";
import { clipHasCanvasLayout, clampClipVolume } from "./clipProperties";
import { collectExportSubtitles } from "./subtitleEdl";

export const toExportEdlPayload = ({ edl }) => {
  if (!edl) {
    return null;
  }

  const clips = Object.values(edl?.clips?.byId || {})
    .filter((clip) => clip.type !== VIDEO_EDITOR_TRACK_TYPE.SUBTITLE)
    .map((clip) => {
      const payload = {
        id: clip.id,
        type: clip.type,
        sourceUrl: clip.sourceUrl,
        inPoint: clip.inPoint,
        outPoint: clip.outPoint,
        position: clip.position,
      };

      if (clipHasCanvasLayout(clip) && clip.layout) {
        payload.layout = clip.layout;
      }

      if (
        clipHasCanvasLayout(clip) &&
        Number.isFinite(Number(clip.layerIndex))
      ) {
        payload.layerIndex = Number(clip.layerIndex);
      }

      if (
        clip.type === VIDEO_EDITOR_TRACK_TYPE.VIDEO ||
        clip.type === VIDEO_EDITOR_TRACK_TYPE.AUDIO
      ) {
        const playbackRate = getClipPlaybackRate({ clip });
        if (playbackRate !== 1) {
          payload.playbackRate = playbackRate;
        }
        const volume = clampClipVolume(clip.volume);
        if (volume !== 1) {
          payload.volume = volume;
        }
      }

      return payload;
    });

  const subtitles = collectExportSubtitles({ edl });

  return {
    fps: edl.fps,
    compositionWidth: edl.compositionWidth,
    compositionHeight: edl.compositionHeight,
    clips,
    ...(subtitles ? { subtitles } : {}),
  };
};
